(() => {
  const helpCenter = document.querySelector('[data-help-center]');
  if (!helpCenter) return;

  const searchInput = helpCenter.querySelector('[data-help-center-search]');
  const clearButton = helpCenter.querySelector('[data-help-center-search-clear]');
  const summary = helpCenter.querySelector('[data-help-center-search-summary]');
  const emptyState = helpCenter.querySelector('[data-help-center-empty]');
  const popularQuestions = helpCenter.querySelector('.help-center__popular');
  const categories = [...helpCenter.querySelectorAll('[data-help-center-category]')];
  const articles = [...helpCenter.querySelectorAll('[data-help-center-article]')];

  if (!searchInput || !categories.length || !articles.length) return;

  const normalize = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  articles.forEach((article) => {
    article.dataset.helpCenterSearchText = normalize(article.textContent);
  });

  const updateResults = () => {
    const query = normalize(searchInput.value);
    let resultCount = 0;

    helpCenter.classList.toggle('is-searching', Boolean(query));

    articles.forEach((article) => {
      const matches = !query || article.dataset.helpCenterSearchText.includes(query);
      article.hidden = !matches;
      if (matches) resultCount += 1;
    });

    categories.forEach((category) => {
      const hasVisibleArticle = [...category.querySelectorAll('[data-help-center-article]')]
        .some((article) => !article.hidden);
      category.hidden = !hasVisibleArticle;
    });

    if (popularQuestions) popularQuestions.hidden = Boolean(query);
    if (clearButton) clearButton.hidden = !query;
    if (emptyState) emptyState.hidden = resultCount > 0;

    if (summary) {
      summary.hidden = !query || resultCount === 0;
      summary.textContent = resultCount === 1
        ? '1 answer found'
        : `${resultCount} answers found`;
    }
  };

  searchInput.addEventListener('input', updateResults);

  clearButton?.addEventListener('click', () => {
    searchInput.value = '';
    updateResults();
    searchInput.focus();
  });

  helpCenter.addEventListener('click', (event) => {
    const articleLink = event.target.closest('a[href^="#help-"]');
    if (!articleLink) return;

    const articleId = articleLink.getAttribute('href').slice(1);
    const article = document.getElementById(articleId);
    if (!(article instanceof HTMLDetailsElement)) return;

    article.open = true;
  });

  if (window.location.hash.startsWith('#help-')) {
    const linkedArticle = document.getElementById(window.location.hash.slice(1));
    if (linkedArticle instanceof HTMLDetailsElement) linkedArticle.open = true;
  }
})();
